(function () {
  /**
   * @ngdoc module
   * @name app.widgets.common.language-switcher
   * @description module that defines language-switcher widgets
   */
  angular.module('app.widgets.common.language-switcher', [
    'binky.core.locale',
    'binky.core.storage-utils',
  ]);
})();
